module.exports = __webpack_public_path__ + "img/Terraza:Jardin.47d76298.png";